import type { IIconsButtonProps } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import SaveDraftSignalButton from "app/pages/sales-intelligence/sub-modules/signals/components/buttons/SaveDraftSignalButton/SaveDraftSignalButton";
import type SignalId from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalId";
import useSaveDraftSignalMutation from "app/pages/sales-intelligence/sub-modules/signals/query/mutations/useSaveDraftSignalMutation";

type Props = Partial<Pick<IIconsButtonProps, "isDisabled" | "className" | "type" | "iconSize">> & {
    signalId: SignalId;
    id: string;
    isSuccess?: boolean;
    onSaveDraftSignal?: (signalId: SignalId) => void;
    onSaveSuccess?: VoidFunction;
};

const SaveDraftSignalButtonContainer = ({
    type = "flat",
    id,
    isSuccess,
    isDisabled,
    className,
    iconSize,
    signalId,
    onSaveDraftSignal,
    onSaveSuccess,
}: Props) => {
    const { mutate, isPending } = useSaveDraftSignalMutation({ keyIdentifier: id, onSuccess: onSaveSuccess });

    const handleClick = (): void => {
        mutate(signalId);
        onSaveDraftSignal?.(signalId);
    };

    return (
        <SaveDraftSignalButton
            className={className}
            type={type}
            iconName={isSuccess ? "checked" : "plus"}
            iconSize={iconSize}
            isLoading={isPending}
            isDisabled={isDisabled || isSuccess}
            onClick={handleClick}
        >
            {isSuccess
                ? translate("si.signals.button.save-draft.success.text")
                : translate("si.signals.button.save-draft.text")}
        </SaveDraftSignalButton>
    );
};

export default SaveDraftSignalButtonContainer;
